$(function () {
  let section = $('#seccionProductos')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, buscar: null },
      productos: [],
      modalTitulo: 'Nuevo producto',
      producto: {}
    },
    mounted() {
      this.getProductos()
    },
    methods: {
        getProductos(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/productos/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal({
                icon: "info",
                title: response.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueApp.productos = response.data.productos.data;
            vueApp.filtros.total = response.data.productos.total;
            vueApp.filtros.per_page = response.data.productos.per_page;
            vueApp.filtros.from = response.data.productos.from;
            vueApp.filtros.to = response.data.productos.to;
          })
          .catch((error) => {
            vueApp.loader = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
      eliminar(id) {
        swal({
          title: '¿Eliminar registro?',
          icon: 'warning',
          buttons: { cancel: 'Cancelar', ok: 'Aceptar', },
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            axios
              .delete('/admin/productos/' + id)
              .then(function (response) {
                if (response.data.error) {
                  swal({
                    icon: "info",
                    title: response.data.error,
                    button: {
                      text: "Aceptar",
                      closeModal: true,
                    },
                  })
                  return
                }
                vueApp.getProductos(1)
              })
              .catch((error) => {
                swal({
                  icon: "info",
                  title: "Ocurrió un error inesperado",
                  button: {
                    text: "Aceptar",
                    closeModal: true,
                  },
                })
              })
          }
        })
      },
      agregar() {
        $('#formProducto')[0].reset()
        this.producto = Object.assign({}, {tipo: "anual"})
        this.modalTitulo = 'Nuevo producto'
        $('#modalProducto').modal('show')
        this.validar()
      },
      editar(producto) {
        $('#formProducto')[0].reset()
        this.producto = Object.assign({}, producto)
        this.modalTitulo = 'Editar producto'
        $('#modalProducto').modal('show')
        this.validar()
      },
      validar() {
        $('#formProducto').validarForm((form) => {
          vueApp.guardar(form)
        })
      },
      guardar(form) {
        $('#btnGuardar').loader('show')
        let formData = new FormData(form)
        axios
          .post('/admin/productos/guardar', formData)
          .then((respuesta) => {
            $('#btnGuardar').loader('hide')
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            $('#modalProducto').modal('hide')
            vueApp.getProductos(1)
          })
          .catch((error) => {
            console.log(error)
            $('#btnGuardar').loader('hide')
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
    },
  })
})
